import { Grid, GridColumn, Search, Separator, TGridColumnWidth } from 'telia-front-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import useStores from '../stores/UseStores';
import { isSmallModuleView } from '../util/ModuleUtil';

export interface MandateSearchProps {
  onSearchChange: (value: string) => void;
}

const MandateSearch = observer((props: MandateSearchProps): React.JSX.Element => {
  const { onSearchChange } = props;
  const {
    translateStore: { translate },
    uiStore: { componentWidth },
  } = useStores();
  const gridWidth: TGridColumnWidth[] = ['xs-12', 'sm-6', isSmallModuleView(componentWidth) ? 'lg-12' : 'xl-4'];

  return (
    <>
      <Grid>
        <GridColumn width={gridWidth}>
          <Search id="mandate-list-search" label={translate('mandates.searchBox')} onChange={onSearchChange} onSubmit={(event) => event.preventDefault()} />
        </GridColumn>
      </Grid>
      <Separator color="invisible" spacing="xsmall" />
    </>
  );
});

export default MandateSearch;
